import { render } from "./StoreFeed.vue?vue&type=template&id=128e3f82&scoped=true&lang=pug"
import script from "./StoreFeed.vue?vue&type=script&lang=js"
export * from "./StoreFeed.vue?vue&type=script&lang=js"

import "./StoreFeed.vue?vue&type=style&index=0&id=128e3f82&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128e3f82"]])

export default __exports__